export default __webpack_public_path__ + "static/mvtec-hdevelopevo-min-48cfc5ad3d85815713e0a7949e9a637a.png";